<template>
  <ProductTable />
</template>
<script setup>
import ProductTable from '@/components/hijo2/ProductTable.vue';
</script> 